import { useSelector } from "react-redux";
import { IApplicationState } from "../../store";
import { 
    CenteredMessage, 
    ImageContainer, 
    MainBody, 
    ShellFooter, 
    ShellHeader, 
    ShellLogoContainer, 
    SubContent, 
    StatusCode, 
    UserMessage, 
    BoldCenteredText, 
    CenteredRolesList, 
    RoleItem, 
    ColouredLink } from "./AccessDenied.styled";
import ShellLogo from '../../images/shell.svg';
import AuthImgage from '../../images/illustration-authentication.svg?react';

export const AccessDeniedPage: React.FC = () => {

    const profilePage = useSelector((state: IApplicationState) => state.profile.profile);
    return (
        <MainBody data-testid="AccessDeniedMainBody">
            <ShellLogoContainer>
                <img src={ShellLogo} alt='' />
                <SubContent>
                    <ShellHeader>Shell</ShellHeader>
                    <ShellFooter>Interconnector Trading</ShellFooter>
                </SubContent>
            </ShellLogoContainer>

            <ImageContainer>
                <AuthImgage />
            </ImageContainer>

            <StatusCode  data-testid="AccessDeniedStatusCode">403</StatusCode>
            <CenteredMessage>Sorry, you are not properly authorized to view this page.</CenteredMessage>
            <UserMessage>
                <BoldCenteredText>Your current roles are:</BoldCenteredText>
                <CenteredRolesList  data-testid="AccessDeniedRoles">
                    {profilePage?.stratosRoles.map((role, index) => (
                        <RoleItem key={index}>{role}</RoleItem>
                    ))}
                </CenteredRolesList> <br></br>
                Please contact ITA Support team citing the reason for elevating your access.
            </UserMessage>
        </MainBody>
    );
};